import React, { useState, useEffect, useMemo } from 'react';
import { db } from '../../firebase';
import { collection, doc, setDoc, getDoc, getDocs, query, orderBy, onSnapshot, updateDoc, deleteDoc, where } from "firebase/firestore"; 
import { auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { Link, useLocation } from 'react-router-dom';

const CLOUD_NAME = "invoice-app";       
const API_KEY = "149469791857382";      
const API_SECRET = "CQJwV5ujAkgYO5BHYKMkGIITbMU"; 

const allCountries = [
  "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan",
  "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire", "Bosnia & Herzegovina", "Botswana", "Brazil", "British Virgin Is.", "Brunei", "Bulgaria", "Burkina Faso", "Burundi",
  "Cambodia", "Cameroon", "Canada", "Canary Islands (The)", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Congo (DPR / Zaire)", "Cook Islands", "Costa Rica", "Croatia", "Cuba", "Curacao", "Cyprus", "Czech Republic",
  "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini (Swaziland)", "Ethiopia",
  "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guinea Rep. (Republic)", "Guinea-Equatorial (Equatorial)", "Guyana",
  "Haiti", "Honduras", "Hong Kong", "Hungary",
  "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast",
  "Jamaica", "Japan", "Jersey", "Jordan",
  "Kazakhstan", "Kenya", "Kiribati", "Korea, D.P.R. Of (North Korea)", "Kosovo", "Kuwait", "Kyrgyzstan",
  "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Macau", "Macedonia (North)", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar",
  "Namibia", "Nauru, Rep. Of", "Nepal", "Netherlands", "Nl. Antilles (Netherlands Antilles)", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norway",
  "Oman",
  "Pakistan", "Palau", "Palestine Authority", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico",
  "Qatar",
  "Reunion Island", "Romania", "Russian Federation", "Rwanda",
  "Saipan", "Samoa", "San Marino", "Sao Tome And Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "Somaliland, Rep Of", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "St. Barthelemy", "St. Eustatius", "St. Kitts", "St Kitts & Nevis", "St. Lucia", "St. Maarten", "St. Vincent", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Tahiti", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos", "Tuvalu",
  "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "USA", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Virgin Islands", "Virgin Islands-British", "Virgin Islands-US",
  "Wallis & Futuna",
  "Yemen", "Yugoslavia",
  "Zambia", "Zimbabwe"
];

const formatCurrency = (num) => {
  if (typeof num !== 'number') { num = parseFloat(num || 0); }
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

const formatWeight = (weight) => {
    if (!weight) return '-';
    const val = parseFloat(weight);
    if (isNaN(val)) return '-';
    return Number.isInteger(val) ? `${val.toFixed(1)} KG` : `${val} KG`;
};

const months = [
    { value: "01", name: "January" }, { value: "02", name: "February" }, { value: "03", name: "March" },
    { value: "04", name: "April" }, { value: "05", name: "May" }, { value: "06", name: "June" },
    { value: "07", name: "July" }, { value: "08", name: "August" }, { value: "09", name: "September" },
    { value: "10", name: "October" }, { value: "11", name: "November" }, { value: "12", name: "December" }
];
const monthsShort = [
    { value: "01", name: "Jan" }, { value: "02", name: "Feb" }, { value: "03", name: "Mar" },
    { value: "04", name: "Apr" }, { value: "05", name: "May" }, { value: "06", name: "Jun" },
    { value: "07", name: "Jul" }, { value: "08", name: "Aug" }, { value: "09", name: "Sep" },
    { value: "10", name: "Oct" }, { value: "11", name: "Nov" }, { value: "12", name: "Dec" }
];

const currentYear = new Date().getFullYear();
const years = Array.from({length: 10}, (_, i) => currentYear + i); 

const roundChargeableWeight = (weight) => {
    const w = parseFloat(weight || 0);
    if (w === 0) return 0;
    const rounded = Math.ceil(w * 2) / 2;
    return rounded;
};

const getNextInvoiceNo = async () => {
    const counterRef = doc(db, "counters", "invoiceCounter");
    const counterSnap = await getDoc(counterRef);
    let newReceiptNo;
    if (!counterSnap.exists()) {
        newReceiptNo = 1001; 
        await setDoc(counterRef, { lastReceiptNo: newReceiptNo });
    } else {
        const lastReceiptNo = counterSnap.data().lastReceiptNo;
        newReceiptNo = lastReceiptNo + 1;
        await updateDoc(counterRef, { lastReceiptNo: newReceiptNo });
    }
    return `INV-${newReceiptNo}`; 
};

const updateFutureInvoices = async (companyId, startYear, startMonth, startFinalTotal) => {
    let currentYear = parseInt(startYear);
    let currentMonth = parseInt(startMonth);
    let currentPreviousDue = startFinalTotal;

    while (true) {
        currentMonth++;
        if (currentMonth > 12) {
            currentMonth = 1;
            currentYear++;
        }
        
        const monthStr = String(currentMonth).padStart(2, '0');
        const nextDocId = `${companyId}_${currentYear}_${monthStr}`;
        const nextRef = doc(db, "invoices", nextDocId);
        
        try {
            const nextSnap = await getDoc(nextRef);
            if (!nextSnap.exists()) break;
            
            const data = nextSnap.data();
            const newFinalTotal = (parseFloat(data.totalBdt || 0) + parseFloat(currentPreviousDue)) - parseFloat(data.totalPaid || 0) - parseFloat(data.discountAmount || 0);
            
            await updateDoc(nextRef, {
                previousDue: parseFloat(currentPreviousDue),
                finalTotalBdt: newFinalTotal
            });
            
            currentPreviousDue = newFinalTotal; 
        } catch (err) {
            console.error("Error updating future invoice chain:", err);
            break; 
        }
    }
};

const DEFAULT_SERVICES = ['DHL', 'FedEx', 'UPS', 'Aramex'];

const NewInvoice = () => {
    const location = useLocation();
    const [selectedCompanyId, setSelectedCompanyId] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(''); 
    const [selectedYear, setSelectedYear] = useState(currentYear);
    
    const [companyList, setCompanyList] = useState([]);
    const [invoiceDocId, setInvoiceDocId] = useState(null); 
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [uid, setUid] = useState(null); 
    const [customerName, setCustomerName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const [customerPhone, setCustomerPhone] = useState(''); 
    const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
    const [exchangeRate, setExchangeRate] = useState(100);
    const [items, setItems] = useState([]);
    const [paidEntries, setPaidEntries] = useState([]); 
    const [previousDue, setPreviousDue] = useState(0); 
    const [showDiscount, setShowDiscount] = useState(false);
    const [discountAmount, setDiscountAmount] = useState('');
    const [allowEditPreviousDue, setAllowEditPreviousDue] = useState(false); 
    const [totalPaid, setTotalPaid] = useState(0);
    const [allowEditTotalPaid, setAllowEditTotalPaid] = useState(false);
    const [showDemandInput, setShowDemandInput] = useState(false); 
    const [showDemandInView, setShowDemandInView] = useState(true);
    const [showUsdInView, setShowUsdInView] = useState(true);
    const [showBdtInView, setShowBdtInView] = useState(true);
    const [editingItemId, setEditingItemId] = useState(null); 
    const [isMonthLocked, setIsMonthLocked] = useState(false);
    const [isYearLocked, setIsYearLocked] = useState(false);
    const [isCustomerInfoVisible, setIsCustomerInfoVisible] = useState(true);
    const [isDemandChargeVisible, setIsDemandChargeVisible] = useState(true);
    const [showBuyerNameInView, setShowBuyerNameInView] = useState(false);
    const [itemUploadingId, setItemUploadingId] = useState(null);

    // --- CHANGED DEFAULT TO 'rate_only' ---
    const [fscCalculationMode, setFscCalculationMode] = useState('rate_only'); 

    const [invoiceNo, setInvoiceNo] = useState('');
    
    const [serviceList, setServiceList] = useState(DEFAULT_SERVICES); 
    const [fscRates, setFscRates] = useState({}); 
    const [demandRates, setDemandRates] = useState({});
    
    const [isFscManuallyEdited, setIsFscManuallyEdited] = useState(false);
    const [isDemandManuallyEdited, setIsDemandManuallyEdited] = useState(false); 
    
    // --- SIGNED BY & FOOTER State ---
    const [signedBy, setSignedBy] = useState('MD. MORSHED'); 
    const [showPaymentFooter, setShowPaymentFooter] = useState(true);
    const [invoiceFooterText, setInvoiceFooterText] = useState('Final'); // New state for footer text option

    const [draftIdFromCn, setDraftIdFromCn] = useState(null);
    const [availableDrafts, setAvailableDrafts] = useState([]); 
    
    const [currentItem, setCurrentItem] = useState({ 
        itemDay: '', 
        itemMonth: months[new Date().getMonth()].value, 
        itemYear: currentYear.toString(), 
        country: '', 
        awbNo: '', 
        buyerName: '', 
        shipment: 'WPX', 
        service: 'DHL', 
        weight: '', 
        rate: '', 
        rateCurrency: 'USD', 
        demandCharge: '', 
        fsc: '',
        cnUrl: '',
        cnFileName: ''
    });

    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            if (user) setUid(user.uid);
        });
        const fetchCompanies = async () => {
            try {
                const q = query(collection(db, 'companies'), orderBy('name'));
                const querySnapshot = await getDocs(q);
                const list = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCompanyList(list);
            } catch (error) { console.error("Error fetching companies: ", error); }
        };
        fetchCompanies();
        return () => unsubscribeAuth();
    }, []);

    useEffect(() => {
        if (location.state && location.state.draftData) {
            const draft = location.state.draftData;
            fillFormFromDraft(draft);
            if (!selectedCompanyId && draft.companyId) {
                setSelectedCompanyId(draft.companyId);
            }
        }
        // eslint-disable-next-line
    }, [location.state]);

    useEffect(() => {
        const fetchDrafts = async () => {
            if (!selectedCompanyId) {
                setAvailableDrafts([]);
                return;
            }
            try {
                const q = query(
                    collection(db, 'cn_drafts'),
                    where('companyId', '==', selectedCompanyId)
                );
                const snap = await getDocs(q);
                const drafts = snap.docs.map(doc => {
                    const data = doc.data();
                    let files = data.cnFiles || [];
                    if (files.length === 0 && data.cnUrl) {
                        files = [{ url: data.cnUrl, name: data.cnFileName || 'Draft File', publicId: data.cnPublicId || null }];
                    }
                    return { id: doc.id, ...data, cnFiles: files };
                });
                drafts.sort((a, b) => new Date(a.date) - new Date(b.date));
                setAvailableDrafts(drafts);
            } catch (error) { console.error("Error fetching drafts:", error); }
        };
        fetchDrafts();
    }, [selectedCompanyId]);

    const fillFormFromDraft = (draft) => {
        let day = '', monthValue = months[new Date().getMonth()].value, year = currentYear.toString();
        
        if (draft.date) {
            const parts = draft.date.split(' ');
            if (parts.length === 3) {
                day = parts[0];
                const monthName = parts[1];
                year = parts[2];
                monthValue = monthsShort.find(m => m.name.toLowerCase() === monthName.toLowerCase())?.value || '01';
            }
        }

        const firstFile = (draft.cnFiles && draft.cnFiles.length > 0) ? draft.cnFiles[0] : { url: draft.cnUrl, name: draft.cnFileName };

        setCurrentItem(prev => ({
            ...prev,
            itemDay: day,
            itemMonth: monthValue,
            itemYear: year,
            country: draft.country || '',
            awbNo: draft.awbNo || '',
            shipment: draft.shipment || 'WPX',
            service: draft.service || 'DHL',
            weight: draft.weight || '',
            rateCurrency: 'USD',
            cnUrl: firstFile.url || '',
            cnFileName: firstFile.name || ''
        }));
        
        setDraftIdFromCn(draft.id); 
        window.scrollTo({ top: 400, behavior: 'smooth' });
        alert("Draft data moved to form! Please add Rate & FSC, then click 'Add Item'.");
    };

    const getPreviousMonthId = (companyId, year, month) => {
        let prevYear = parseInt(year);
        let prevMonthInt = parseInt(month) - 1;
        if (prevMonthInt === 0) { prevMonthInt = 12; prevYear = prevYear - 1; }
        const prevMonthString = String(prevMonthInt).padStart(2, '0');
        return `${companyId}_${prevYear}_${prevMonthString}`;
    };

    const uploadToCloudinary = async (file) => {
        const timestamp = Math.round((new Date()).getTime() / 1000);
        const params = { timestamp: timestamp, folder: 'cn_uploads' };
        
        const sortedKeys = Object.keys(params).sort();
        const stringToSign = sortedKeys.map(key => `${key}=${params[key]}`).join('&') + API_SECRET;
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToSign);
        const hashBuffer = await crypto.subtle.digest('SHA-1', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const signature = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

        const formData = new FormData();
        formData.append("file", file);
        formData.append("api_key", API_KEY);
        formData.append("timestamp", timestamp);
        formData.append("folder", 'cn_uploads');
        formData.append("signature", signature);

        const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, {
            method: "POST", body: formData
        });
        const resData = await response.json();
        if (resData.error) throw new Error(resData.error.message);
        
        let url = resData.secure_url;
        if (resData.format === 'pdf') {
            url = url.replace('/upload/', '/upload/fl_attachment/');
        }
        return { url: url, name: file.name };
    };

    const handleCnUploadForItem = async (e, itemId) => {
        const file = e.target.files[0];
        if(!file) return;
        
        if(!window.confirm(`Upload ${file.name} to this item?`)) return;

        setItemUploadingId(itemId);
        try {
            const { url, name } = await uploadToCloudinary(file);
            setItems(prevItems => prevItems.map(item => {
                if(item.id === itemId) {
                    return { ...item, cnUrl: url, cnFileName: name };
                }
                return item;
            }));
            alert("CN Uploaded to Item!");
        } catch(error) {
            console.error(error);
            alert("Upload failed: " + error.message);
        }
        setItemUploadingId(null);
    };

    useEffect(() => {
        let previousDueListener = () => {}; 
        let currentInvoiceListener = () => {}; 

        if (!selectedCompanyId || !selectedMonth || !selectedYear) {
            setInvoiceDocId(null);
            setItems([]);
            setPaidEntries([]);
            setPreviousDue(0);
            setTotalPaid(0); 
            setAllowEditTotalPaid(false); 
            setFscRates({});
            setDemandRates({}); 
            setServiceList(DEFAULT_SERVICES);
            setInvoiceNo(''); 
            return; 
        }

        const docId = `${selectedCompanyId}_${selectedYear}_${selectedMonth}`;
        setInvoiceDocId(docId);
        
        const companyData = companyList.find(c => c.id === selectedCompanyId);
        if (companyData) {
            setCustomerName(companyData.customerName || '');
            setCustomerAddress(companyData.address || '');
            setCustomerPhone(companyData.phone || ''); 
        }

        if (!allowEditPreviousDue) {
            try {
                const prevMonthDocId = getPreviousMonthId(selectedCompanyId, selectedYear, selectedMonth);
                const prevDocRef = doc(db, "invoices", prevMonthDocId);
                previousDueListener = onSnapshot(prevDocRef, (docSnap) => {
                    if (docSnap.exists()) setPreviousDue(docSnap.data().finalTotalBdt || 0); 
                    else setPreviousDue(0); 
                }, (error) => { console.error("Error listening to previous due: ", error); setPreviousDue(0); });
            } catch (error) { console.error("Error setting up listener: ", error); setPreviousDue(0); }
        }
        
        setLoadingInvoice(true);
        const docRef = doc(db, "invoices", docId);
        
        currentInvoiceListener = onSnapshot(docRef, (docSnap) => { 
            if (docSnap.exists()) {
                const data = docSnap.data();
                setInvoiceDate(data.invoiceDate || new Date().toISOString().split('T')[0]);
                setExchangeRate(data.exchangeRate || 100);
                setItems(data.items || []);
                setPaidEntries(data.paidEntries || []);
                setDiscountAmount(data.discountAmount || '');
                setShowDiscount(!!data.discountAmount);
                if (data.previousDue !== undefined && allowEditPreviousDue) {
                    setPreviousDue(data.previousDue);
                }
                const calculatedPaid = (data.paidEntries || []).reduce((acc, entry) => acc + parseFloat(entry.amount || 0), 0);
                if (data.allowEditTotalPaid) {
                    setTotalPaid(data.totalPaid || 0);
                    setAllowEditTotalPaid(true);
                } else {
                    setTotalPaid(calculatedPaid);
                    setAllowEditTotalPaid(false);
                }
                setShowDemandInView(data.showDemandInView !== undefined ? data.showDemandInView : true);
                setShowUsdInView(data.showUsdInView !== undefined ? data.showUsdInView : true);
                setShowBdtInView(data.showBdtInView !== undefined ? data.showBdtInView : true);
                setInvoiceNo(data.invoiceNo || ''); 
                setFscRates(data.fscRates || {});
                setDemandRates(data.demandRates || {}); 
                setServiceList(data.serviceList || DEFAULT_SERVICES);
                setFscCalculationMode(data.fscCalculationMode || 'rate_only'); // Set to rate_only if undefined
                setShowBuyerNameInView(data.showBuyerNameInView || false); 
                
                // --- LOAD SIGNED BY & FOOTER ---
                setSignedBy(data.signedBy || 'MD. MORSHED');
                setShowPaymentFooter(data.showPaymentFooter !== undefined ? data.showPaymentFooter : true);
                setInvoiceFooterText(data.invoiceFooterText || 'Final');

            } else { 
                setItems([]);
                setPaidEntries([]); 
                setDiscountAmount('');
                setShowDiscount(false);
                setTotalPaid(0); 
                setAllowEditTotalPaid(false); 
                setInvoiceDate(new Date().toISOString().split('T')[0]);
                setShowDemandInView(true); 
                setShowUsdInView(true);
                setShowBdtInView(true); 
                setFscRates({});
                setDemandRates({}); 
                setServiceList(DEFAULT_SERVICES); 
                setInvoiceNo(''); 
                setFscCalculationMode('rate_only'); // Defaults to rate_only
                setShowBuyerNameInView(false);
                setSignedBy('MD. MORSHED');
                setShowPaymentFooter(true);
                setInvoiceFooterText('Final');
            }
            setLoadingInvoice(false);
        }, (error) => {
            console.error("Error fetching invoice real-time: ", error);
            setLoadingInvoice(false);
        });

        return () => {
            previousDueListener(); 
            currentInvoiceListener();
        };

    }, [selectedCompanyId, selectedMonth, selectedYear, companyList, allowEditPreviousDue]); 

    const handleFscRateChange = (serviceName, value) => {
        setFscRates(prevRates => ({
            ...prevRates,
            [serviceName.toUpperCase()]: parseFloat(value) || 0
        }));
    };
    const handleDemandRateChange = (serviceName, value) => {
        setDemandRates(prevRates => ({
            ...prevRates,
            [serviceName.toUpperCase()]: parseFloat(value) || 0
        }));
    };
    
    const handleItemChange = (e) => { 
        const { name, value } = e.target;
        if (name === 'fsc') setIsFscManuallyEdited(true); 
        if (name === 'demandCharge') setIsDemandManuallyEdited(true);
        if (name === 'rate' || name === 'service' || name === 'weight' || name === 'rateCurrency') {
            setIsFscManuallyEdited(false);
            setIsDemandManuallyEdited(false); 
        }
        setCurrentItem(prev => ({ ...prev, [name]: value })); 
    };

    useEffect(() => {
        if (currentItem.rateCurrency === 'BDT') {
            setCurrentItem(prev => ({ ...prev, demandCharge: '' }));
            return;
        }

        if (!showDemandInput) { 
            setCurrentItem(prev => ({ ...prev, demandCharge: '' }));
            return;
        }
        if (isDemandManuallyEdited) return;

        const weight = currentItem.weight;
        const service = currentItem.service;
        if (weight > 0 && service) {
            const chargeableWeight = roundChargeableWeight(weight); 
            const upperService = service.toUpperCase();
            const demandRate = parseFloat(demandRates[upperService] || 0); 
            const totalDemandCharge = chargeableWeight * demandRate;
            setCurrentItem(prev => ({ ...prev, demandCharge: totalDemandCharge.toFixed(2) }));
        } else {
            setCurrentItem(prev => ({ ...prev, demandCharge: '' }));
        }
    }, [currentItem.weight, currentItem.service, showDemandInput, demandRates, isDemandManuallyEdited, currentItem.rateCurrency]); 

    useEffect(() => {
        if (currentItem.rateCurrency === 'BDT') {
            setCurrentItem(prev => ({ ...prev, fsc: '' }));
            return;
        }

        if (isFscManuallyEdited) return; 
        const rate = parseFloat(currentItem.rate || 0);
        const totalDemand = parseFloat(currentItem.demandCharge || 0); 
        const service = currentItem.service;
        
        let baseForFsc = rate;
        if (fscCalculationMode === 'rate_plus_demand') {
            baseForFsc += totalDemand; 
        } 

        if (baseForFsc > 0 && service) {
            const upperService = service.toUpperCase(); 
            const fscPercent = parseFloat(fscRates[upperService] || 0);
            if (fscPercent > 0) {
                const calculatedFsc = (baseForFsc * fscPercent) / 100;
                setCurrentItem(prev => ({ ...prev, fsc: calculatedFsc.toFixed(2) }));
            } else {
                 setCurrentItem(prev => ({ ...prev, fsc: '' }));
            }
        } else {
             setCurrentItem(prev => ({ ...prev, fsc: '' }));
        }
    }, [currentItem.rate, currentItem.demandCharge, currentItem.service, fscRates, isFscManuallyEdited, fscCalculationMode, currentItem.rateCurrency]);

    const resetCurrentItem = () => {
        setCurrentItem({
            itemDay: '', 
            itemMonth: isMonthLocked ? currentItem.itemMonth : months[new Date().getMonth()].value,
            itemYear: isYearLocked ? currentItem.itemYear : currentYear.toString(),
            country: '', awbNo: '', buyerName: '', shipment: 'WPX', service: 'DHL',
            weight: '', rate: '', rateCurrency: 'USD', demandCharge: '', fsc: '',
            cnUrl: '', cnFileName: ''
        });
        setIsFscManuallyEdited(false); 
        setIsDemandManuallyEdited(false);
    }

    const handleSubmitItem = async (e) => { 
        e.preventDefault(); 
        
        if (!currentItem.itemDay || !currentItem.country || !currentItem.awbNo || !currentItem.weight || !currentItem.rate) {
            alert("Please enter Date, Country, AWB No, Weight, and Rate to add an item.");
            return;
        }

        const finalWeight = parseFloat(currentItem.weight || 0);
        const monthName = monthsShort.find(m => m.value === currentItem.itemMonth)?.name || 'Jan';
        const formattedDay = String(currentItem.itemDay || '01').padStart(2, '0');
        const formattedYear = currentItem.itemYear || currentYear.toString();
        const finalDateString = `${formattedDay} ${monthName} ${formattedYear}`;
        
        const serviceName = currentItem.service;
        if (serviceName) {
            const upperService = serviceName.toUpperCase();
            const exists = serviceList.some(s => s.toUpperCase() === upperService);
            if (!exists) {
                setServiceList(prevList => [...prevList, serviceName]);
                if (fscRates[upperService] === undefined) { handleFscRateChange(upperService, 0); }
                if (demandRates[upperService] === undefined) { handleDemandRateChange(upperService, 0); }
            }
        }
        
        const itemData = {
            ...currentItem, 
            date: finalDateString, 
            weight: finalWeight, 
            demandCharge: showDemandInput ? parseFloat(currentItem.demandCharge || 0) : 0,
            fsc: parseFloat(currentItem.fsc || 0), 
            service: serviceName.toUpperCase(),
            rateCurrency: currentItem.rateCurrency || 'USD',
            cnUrl: currentItem.cnUrl || '',
            cnFileName: currentItem.cnFileName || ''
        };
        
        delete itemData.itemDay;
        delete itemData.itemMonth;
        delete itemData.itemYear;

        const sortItemsByDate = (items) => {
            return items.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateA - dateB; 
            });
        };

        if (editingItemId !== null) {
            setItems(prevItems => {
                const updatedItems = prevItems.map(item => item.id === editingItemId ? { ...itemData, id: editingItemId } : item);
                return sortItemsByDate(updatedItems); 
            });
            setEditingItemId(null); 
        } else {
            setItems(prevItems => {
                const newItem = { ...itemData, id: Date.now() };
                const updatedItems = [...prevItems, newItem];
                return sortItemsByDate(updatedItems); 
            });
        }
        
        if (draftIdFromCn) {
            try {
                await deleteDoc(doc(db, 'cn_drafts', draftIdFromCn));
                setAvailableDrafts(prev => prev.filter(d => d.id !== draftIdFromCn));
                console.log("Draft deleted successfully");
            } catch (err) { console.error("Error deleting draft:", err); }
            setDraftIdFromCn(null);
        }

        resetCurrentItem();
    };

    const handleEditItem = (id) => {
        const itemToEdit = items.find(item => item.id === id);
        if (itemToEdit && itemToEdit.date) {
            const dateParts = itemToEdit.date.split(' '); 
            let day = '', monthName = 'Jan', year = currentYear.toString();
            if (dateParts.length >= 3) { day = dateParts[0]; monthName = dateParts[1]; year = dateParts[2]; }
            const monthValue = monthsShort.find(m => m.name.toLowerCase() === monthName.toLowerCase())?.value || '01'; 
            
            setCurrentItem({
                ...itemToEdit,
                itemDay: day,
                itemMonth: monthValue,
                itemYear: year,
                buyerName: itemToEdit.buyerName || '', 
                demandCharge: String(itemToEdit.demandCharge || ''),
                fsc: String(itemToEdit.fsc || ''),
                rateCurrency: itemToEdit.rateCurrency || 'USD',
                cnUrl: itemToEdit.cnUrl || '',
                cnFileName: itemToEdit.cnFileName || ''
            });
            
            setEditingItemId(id);       
            if (parseFloat(itemToEdit.demandCharge || 0) > 0) {
                setShowDemandInput(true);
            }
            setIsFscManuallyEdited(true); 
            setIsDemandManuallyEdited(true);
        }
    };

    const handleRemoveItem = (id) => {
        if (id === editingItemId) { setEditingItemId(null); resetCurrentItem(); }
        setItems(prev => prev.filter(item => item.id !== id));
    };
    
    const calculateItemTotal = (item, currentExchangeRate) => {
        if (item.rateCurrency === 'BDT') {
            const rate = parseFloat(item.rate || 0);
            const weight = parseFloat(item.weight || 0);
            const totalBdtForItem = rate * weight;
            const exRate = parseFloat(currentExchangeRate || 100) || 1;
            return totalBdtForItem / exRate;
        }
        const rate = parseFloat(item.rate || 0);
        const fsc = parseFloat(item.fsc || 0);
        const demandTotal = parseFloat(item.demandCharge || 0); 
        return (rate + fsc + demandTotal);
    };

    const totalUsd = useMemo(() => items.reduce((acc, item) => acc + calculateItemTotal(item, exchangeRate), 0), [items, exchangeRate]);
    const totalBdt = useMemo(() => totalUsd * parseFloat(exchangeRate || 0), [totalUsd, exchangeRate]);
    const finalTotalBdt = useMemo(() => (totalBdt + parseFloat(previousDue || 0)) - parseFloat(totalPaid || 0) - parseFloat(discountAmount || 0), [totalBdt, previousDue, totalPaid, discountAmount]);
    
    const handleDeletePaymentEntry = async (entry) => {
        if (!window.confirm(`Are you sure?`)) return;
        try {
            const invoiceRef = doc(db, "invoices", invoiceDocId);
            const updatedPaidEntries = paidEntries.filter(e => e.id !== entry.id);
            let newTotalPaid = totalPaid; 
            if (!allowEditTotalPaid) {
                newTotalPaid = updatedPaidEntries.reduce((acc, entry) => acc + parseFloat(entry.amount || 0), 0);
                setTotalPaid(newTotalPaid); 
            }
            const newFinalTotalBdt = (totalBdt + parseFloat(previousDue || 0)) - newTotalPaid - parseFloat(discountAmount || 0);
            await updateDoc(invoiceRef, { paidEntries: updatedPaidEntries, totalPaid: newTotalPaid, finalTotalBdt: newFinalTotalBdt });
        } catch (error) { console.error(error); alert("Error removing payment."); }
    }
    
    const handleSaveInvoice = async () => {
        if (!invoiceDocId || !uid) { alert("Please select a company, month, and year first."); return; }
        let finalInvoiceNo = invoiceNo; 
        if (!finalInvoiceNo) { 
            try {
                finalInvoiceNo = await getNextInvoiceNo(); 
                setInvoiceNo(finalInvoiceNo); 
            } catch (err) { alert("Error generating new invoice number."); return; }
        }
        try {
            const sortedItems = items.sort((a, b) => {
                const dateA = new Date(a.date);
                const dateB = new Date(b.date);
                return dateA - dateB; 
            });
            const invoiceData = {
                userId: uid, 
                companyId: selectedCompanyId,
                companyName: companyList.find(c => c.id === selectedCompanyId)?.name,
                customerName, customerAddress, customerPhone, invoiceDate,
                invoiceYearMonth: `${selectedYear}-${selectedMonth}`,
                invoiceNo: finalInvoiceNo, 
                exchangeRate: parseFloat(exchangeRate || 0),
                items: sortedItems, 
                previousDue: parseFloat(previousDue || 0), 
                paidEntries, 
                totalPaid: parseFloat(totalPaid || 0),
                allowEditTotalPaid: allowEditTotalPaid, 
                discountAmount: parseFloat(discountAmount || 0), 
                totalUsd: totalUsd, totalBdt: totalBdt, finalTotalBdt: finalTotalBdt,
                lastUpdatedAt: new Date(),
                showDemandInView: showDemandInView, showUsdInView: showUsdInView, showBdtInView: showBdtInView, 
                fscRates: fscRates, demandRates: demandRates, serviceList: serviceList,
                fscCalculationMode: fscCalculationMode, showBuyerNameInView: showBuyerNameInView,
                signedBy: signedBy,
                showPaymentFooter: showPaymentFooter,
                invoiceFooterText: invoiceFooterText // --- Saving new footer option
            };
            await setDoc(doc(db, "invoices", invoiceDocId), invoiceData);
            await updateFutureInvoices(selectedCompanyId, selectedYear, selectedMonth, finalTotalBdt);
            alert("Invoice Saved/Updated Successfully!");
        } catch (e) { alert("Error saving invoice."); }
    };

    const filteredCountries = allCountries.filter(country => country.toLowerCase().startsWith(currentItem.country.toLowerCase()));
    
    return (
        <div className='new-invoice-container'>
            <p className='new-invoice-heading'>Create / Edit Monthly Bill</p>

            <div className='form-section'>
                <h3>Select Invoice</h3>
                <div className='form-grid' style={{gridTemplateColumns: '2fr 1fr 1fr'}}>
                    <div><label>Company:</label><select value={selectedCompanyId} onChange={e => setSelectedCompanyId(e.target.value)}><option value="">-- Select Company --</option>{companyList.map(comp => (<option key={comp.id} value={comp.id}>{comp.name}</option>))}</select></div>
                    <div>
                        <label>Month:</label>
                        <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
                            <option value="" disabled>-- Select Month --</option>
                            {months.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}
                        </select>
                    </div>
                    <div><label>Year:</label><select value={selectedYear} onChange={e => setSelectedYear(e.target.value)}>{years.map(y => <option key={y} value={y}>{y}</option>)}</select></div>
                </div>
            </div>

            {(selectedCompanyId && selectedMonth) && !loadingInvoice && (
                <>
                    <div className='form-grid' style={{ gridTemplateColumns: '2fr 1fr', alignItems: 'flex-start', gap: '24px' }}>
                        <div className='form-section' style={{ margin: 0 }}> 
                            <div className='form-section-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isCustomerInfoVisible ? '20px' : '0' }}>
                                <h3>Customer Information</h3>
                                <button type="button" onClick={() => setIsCustomerInfoVisible(!isCustomerInfoVisible)} className='view-btn' style={{ padding: '5px 10px', fontSize: '12px', height: 'auto', margin: 0 }}>{isCustomerInfoVisible ? 'Hide' : 'Show'}</button>
                            </div>
                            {isCustomerInfoVisible && (
                                <div className='form-grid' style={{marginTop: '20px'}}>
                                    <div className='form-grid-item-full'><label>Customer Name:</label><input value={customerName} readOnly disabled /></div>
                                    <div className='form-grid-item-full'><label>Address:</label><input value={customerAddress} readOnly disabled /></div>
                                    <div><label>Phone:</label><input value={customerPhone} readOnly disabled /></div>
                                    <div><label>Invoice No:</label><input value={invoiceNo || '[Will be generated on save]'} readOnly disabled style={{fontWeight: 'bold', color: invoiceNo ? 'red' : '#777'}} /></div>
                                    <div><label>Invoice Date (Bill Date):</label><input type='date' value={invoiceDate} onChange={e => setInvoiceDate(e.target.value)} /></div>
                                    <div><label>USD to BDT Rate:</label><input type='number' value={exchangeRate} onChange={e => setExchangeRate(e.target.value)} onWheel={(e) => e.target.blur()} /></div>
                                </div>
                            )}
                        </div>
                        <div className='form-section' style={{ margin: 0 }}>
                            <div className='form-section-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: isDemandChargeVisible ? '10px' : '0' }}>
                                <h3>Demand Charge ($/KG)</h3>
                                <button type="button" onClick={() => setIsDemandChargeVisible(!isDemandChargeVisible)} className='view-btn' style={{ padding: '5px 10px', fontSize: '12px', height: 'auto', margin: 0 }}>{isDemandChargeVisible ? 'Hide' : 'Show'}</button>
                            </div>
                            {isDemandChargeVisible && (
                                <div className='form-grid' style={{gridTemplateColumns: '1fr', marginTop: '10px'}}>
                                    {serviceList.map(service => (
                                        <div key={service}>
                                            <label>{service.toUpperCase()} ($/KG):</label>
                                            <input type="number" value={demandRates[service.toUpperCase()] || ''} placeholder='0.00' onChange={(e) => handleDemandRateChange(service.toUpperCase(), e.target.value)} onWheel={(e) => e.target.blur()} />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className='form-section'>
                         <h4>FSC Management (% For this Invoice)</h4>
                         <div className='form-grid' style={{gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', marginTop: '10px'}}>
                             {serviceList.map(service => (
                                 <div key={service}>
                                     <label>{service.toUpperCase()} FSC (%):</label>
                                     <input type="number" value={fscRates[service.toUpperCase()] || ''} placeholder='0' onChange={(e) => handleFscRateChange(service.toUpperCase(), e.target.value)} onWheel={(e) => e.target.blur()} />
                                 </div>
                             ))}
                         </div>
                    </div>

                    {availableDrafts.length > 0 && (
                        <div className='form-section' style={{borderTop: '3px solid #e67e22'}}>
                            <h3 style={{color: '#e67e22'}}>Pending Drafts from CN Upload ({availableDrafts.length})</h3>
                            <div className="invoice-preview-table full-width-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>AWB</th>
                                            <th>Country</th>
                                            <th>Weight</th>
                                            <th>Service</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {availableDrafts.map(draft => (
                                            <tr key={draft.id}>
                                                <td>{draft.date}</td>
                                                <td>{draft.awbNo}</td>
                                                <td>{draft.country}</td>
                                                <td>{formatWeight(draft.weight)}</td>
                                                <td>{draft.service}</td>
                                                <td>
                                                    <button 
                                                        onClick={() => fillFormFromDraft(draft)} 
                                                        className='edit-btn' 
                                                        style={{backgroundColor: '#e67e22', color: 'white'}}
                                                    >
                                                        Move to Entry
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    <div className='form-section'>
                        <h3>{editingItemId ? 'Edit Bill Item' : 'Add Bill Item'}</h3>
                        <form onSubmit={handleSubmitItem}>
                            <div className='item-entry-controls' style={{ display: 'flex', gap: '20px', marginBottom: '20px', flexWrap: 'wrap', padding: '10px', backgroundColor: '#f9f9f9', borderRadius: '6px', alignItems: 'center' }}>
                                <label style={{display: 'flex', alignItems: 'center', fontWeight: 600, cursor: 'pointer', margin: 0}}><input type="checkbox" checked={isMonthLocked} onChange={(e) => setIsMonthLocked(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Lock Month</label>
                                <label style={{display: 'flex', alignItems: 'center', fontWeight: 600, cursor: 'pointer', margin: 0}}><input type="checkbox" checked={isYearLocked} onChange={(e) => setIsYearLocked(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Lock Year</label>
                                <label style={{display: 'flex', alignItems: 'center', fontWeight: 600, cursor: 'pointer', margin: 0}}><input type="checkbox" checked={showDemandInput} onChange={(e) => setShowDemandInput(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Add Demand Charge?</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginLeft: '15px', paddingLeft: '20px', borderLeft: '2px solid #ccc' }}>
                                    <span style={{fontWeight: '600', fontSize: '13px', color: '#555'}}>FSC Mode:</span>
                                    <label style={{fontWeight: 'normal', fontSize: '13px', display: 'flex', alignItems: 'center', cursor: 'pointer'}}><input type="radio" name="fsc_mode_group" checked={fscCalculationMode === 'rate_plus_demand'} onChange={() => setFscCalculationMode('rate_plus_demand')} style={{marginRight: '5px', width: 'auto'}} /> On Rate + Demand</label>
                                    <label style={{fontWeight: 'normal', fontSize: '13px', display: 'flex', alignItems: 'center', cursor: 'pointer'}}><input type="radio" name="fsc_mode_group" checked={fscCalculationMode === 'rate_only'} onChange={() => setFscCalculationMode('rate_only')} style={{marginRight: '5px', width: 'auto'}} /> On Rate Only</label>
                                </div>
                                <label style={{display: 'flex', alignItems: 'center', fontWeight: 600, cursor: 'pointer', margin: 0, marginLeft: '20px', borderLeft: '2px solid #ccc', paddingLeft: '20px'}}><input type="checkbox" checked={showBuyerNameInView} onChange={(e) => setShowBuyerNameInView(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Show Buyer Name?</label>
                            </div>

                            <div className='form-grid' style={{gridTemplateColumns: '1.5fr 1fr 1fr 1.5fr 1fr', gap: '15px', alignItems: 'flex-start'}}>
                                <div>
                                    <label>Date (Day/Month/Year)</label>
                                    <div className='date-inputs-group' style={{display: 'grid', gridTemplateColumns: '1fr 1.2fr 1fr', gap: '5px'}}>
                                        <input name='itemDay' value={currentItem.itemDay} onChange={handleItemChange} placeholder='Day' type='number' onWheel={(e) => e.target.blur()} />
                                        <select name='itemMonth' value={currentItem.itemMonth} onChange={handleItemChange} disabled={isMonthLocked}>{monthsShort.map(m => <option key={m.value} value={m.value}>{m.name}</option>)}</select>
                                        <input name='itemYear' value={currentItem.itemYear} onChange={handleItemChange} placeholder='Year' type='number' disabled={isYearLocked} onWheel={(e) => e.target.blur()} />
                                    </div>
                                </div>
                                <div><label>Country (Filtered)</label><input name='country' value={currentItem.country} onChange={handleItemChange} placeholder='Type letter to filter...' list="filtered-country-list" /></div>
                                <div><label>AWB No.</label><input name='awbNo' value={currentItem.awbNo} onChange={handleItemChange} placeholder='AWB No.' /></div>
                                
                                {showBuyerNameInView && (
                                    <div><label>Buyer Name</label><input name='buyerName' value={currentItem.buyerName} onChange={handleItemChange} placeholder='Buyer Name' /></div>
                                )}
                                
                                <div><label>Shipment</label><input name='shipment' value={currentItem.shipment} onChange={handleItemChange} placeholder='Shipment' list="shipment-list" /></div>
                            </div>

                            <div className='form-grid' style={{gridTemplateColumns: showDemandInput ? '1fr 1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr', gap: '15px', marginTop: '15px', alignItems: 'flex-start'}}>
                                <div><label>Service</label><input name='service' value={currentItem.service} onChange={handleItemChange} placeholder='Service' list="service-list" /></div>
                                <div><label>Weight (KG)</label><input type='number' name='weight' value={currentItem.weight} onChange={handleItemChange} placeholder='Weight' onWheel={(e) => e.target.blur()} /></div>
                                
                                <div>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '5px', justifyContent: 'space-between' }}>
                                        Rate
                                        <select name='rateCurrency' value={currentItem.rateCurrency || 'USD'} onChange={handleItemChange} style={{ padding: '0px', fontSize: '11px', width: 'auto' }}>
                                            <option value="USD">USD ($)</option>
                                            <option value="BDT">BDT (৳)</option>
                                        </select>
                                    </label>
                                    <input type='number' name='rate' value={currentItem.rate} onChange={handleItemChange} placeholder={currentItem.rateCurrency === 'BDT' ? 'Rate/KG (BDT)' : 'Rate ($)'} onWheel={(e) => e.target.blur()} />
                                </div>
                                
                                {showDemandInput && (
                                    <div>
                                        <label>Total Demand ($) (Auto)</label>
                                        <input type='number' name='demandCharge' value={currentItem.demandCharge} onChange={handleItemChange} placeholder='0.00' disabled={currentItem.rateCurrency === 'BDT'} onWheel={(e) => e.target.blur()} />
                                    </div>
                                )}
                                
                                <div><label>FSC ($) (Auto)</label><input type='number' name='fsc' value={currentItem.fsc} onChange={handleItemChange} placeholder='FSC ($)' disabled={currentItem.rateCurrency === 'BDT'} onWheel={(e) => e.target.blur()} /></div>
                            </div>
                            
                            {currentItem.cnUrl && (
                                <div style={{marginTop: '10px', padding: '5px', background: '#e1f5fe', fontSize: '12px', borderRadius: '4px'}}>
                                    <strong>Attached CN: </strong> 
                                    <a href={currentItem.cnUrl} target="_blank" rel="noreferrer" style={{marginLeft: '5px', color: '#0288d1'}}>{currentItem.cnFileName}</a>
                                </div>
                            )}

                            <div className='button-group' style={{marginTop: '20px', display: 'flex', gap: '10px'}}>
                                <button type='submit' className='add-item-btn' style={{marginTop: 0, width: 'auto'}}>{editingItemId ? 'Update Item' : 'Add Item'}</button>
                                {editingItemId && (<button type="button" className="cancel-edit-btn" style={{marginTop: 0}} onClick={() => { setEditingItemId(null); resetCurrentItem(); }}>Cancel Edit</button>)}
                            </div>

                            <datalist id="filtered-country-list">{filteredCountries.map(c => <option key={c} value={c} />)}</datalist>
                            <datalist id="shipment-list"><option value="WPX" /><option value="DOX" /><option value="WPX(sms)" /></datalist>
                            <datalist id="service-list">{serviceList.map(service => <option key={service} value={service} />)}</datalist>
                        </form>
                    </div>

                    {items.length > 0 &&
                        <div className='form-section'>
                            <h3>Courier Bill Items</h3>
                            <table className='invoice-preview-table'>
                                <thead>
                                    <tr>
                                        <th>Date</th><th>Country</th><th>AWB No.</th><th>Shipment</th><th>Service</th><th>Weight</th><th>Rate</th><th>Demand</th><th>FSC</th><th>Total ($)</th><th>Total (BDT)</th>
                                        <th>Action</th>
                                        <th>Upload CN</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item) => (
                                        <tr key={item.id} className={item.id === editingItemId ? 'editing-row' : ''}>
                                            <td>{item.date}</td><td>{item.country}</td><td>{item.awbNo}</td><td>{item.shipment}</td><td>{item.service}</td>
                                            
                                            <td>{formatWeight(item.weight)}</td>
                                            
                                            <td>{item.rateCurrency === 'BDT' ? '৳' : '$'} {formatCurrency(item.rate)}</td><td>$ {formatCurrency(item.demandCharge)}</td><td>$ {formatCurrency(item.fsc)}</td><td>$ {formatCurrency(calculateItemTotal(item, exchangeRate))}</td>
                                            <td style={{fontWeight: 'bold', color: '#0972d4'}}>৳ {formatCurrency(calculateItemTotal(item, exchangeRate) * exchangeRate)}</td>
                                            
                                            <td className='action-buttons'>
                                                <button type='button' onClick={() => handleEditItem(item.id)} className='edit-btn'>Edit</button>
                                                <button type='button' onClick={() => handleRemoveItem(item.id)} className='remove-btn'>X</button>
                                            </td>

                                            <td>
                                                {itemUploadingId === item.id ? (
                                                    <span style={{fontSize: '11px', color: 'orange', fontWeight: 'bold'}}>Uploading...</span>
                                                ) : (
                                                    <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                                                        {item.cnUrl ? (
                                                            <a href={item.cnUrl} target="_blank" rel="noreferrer" style={{color: '#2980b9', fontWeight: 'bold', fontSize: '11px', textDecoration: 'underline'}}>View CN</a>
                                                        ) : (
                                                            <span style={{fontSize: '11px', color: '#aaa'}}>No File</span>
                                                        )}
                                                        <input 
                                                            type="file" 
                                                            onChange={(e) => handleCnUploadForItem(e, item.id)} 
                                                            style={{width: '90px', fontSize: '10px'}} 
                                                        />
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    }

                    <div className='form-section view-options'>
                        <h3>Invoice View Options</h3>
                        
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '20px'}}>
                            
                            <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                                <label><input type="checkbox" checked={showBdtInView} onChange={(e) => setShowBdtInView(e.target.checked)} /> Show BDT columns and Total</label>
                                <label><input type="checkbox" checked={showUsdInView} onChange={(e) => setShowUsdInView(e.target.checked)} /> Show USD columns (Rate, FSC, etc.) in final invoice</label>
                                <label><input type="checkbox" checked={showDemandInView} onChange={(e) => setShowDemandInView(e.target.checked)} disabled={!showUsdInView} /> Show 'Demand Charge' as a separate column (if unchecked, it will be added to the Rate)</label>
                            </div>

                            <div style={{textAlign: 'right', minWidth: '250px'}}>
                                <label style={{fontWeight: 'bold', marginBottom: '8px', display: 'block'}}>Best Regards (Signed By):</label>
                                <select 
                                    value={signedBy} 
                                    onChange={(e) => setSignedBy(e.target.value)}
                                    style={{
                                        padding: '8px', 
                                        borderRadius: '4px', 
                                        border: '1px solid #ccc', 
                                        width: '100%',
                                        fontSize: '14px'
                                    }}
                                >
                                    <option value="MD. MORSHED">MD. MORSHED</option>
                                    <option value="ANIS KHAN">ANIS KHAN</option>
                                </select>
                                
                                {/* --- NEW FOOTER TEXT DROPDOWN --- */}
                                <div style={{marginTop: '15px', textAlign: 'right'}}>
                                    <label style={{fontWeight: 'bold', marginBottom: '8px', display: 'block'}}>Footer Text / Note:</label>
                                    <select 
                                        value={invoiceFooterText} 
                                        onChange={(e) => setInvoiceFooterText(e.target.value)}
                                        style={{
                                            padding: '8px', 
                                            borderRadius: '4px', 
                                            border: '1px solid #ccc', 
                                            width: '100%',
                                            fontSize: '14px'
                                        }}
                                    >
                                        <option value="Final">Final Notice (System-generated)</option>
                                        <option value="Demo">Demo / Estimate Notice</option>
                                        <option value="ThankYou">Thank You Note</option>
                                    </select>
                                </div>

                                <div style={{marginTop: '15px'}}>
                                    <label style={{cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                                        <input 
                                            type="checkbox" 
                                            checked={showPaymentFooter} 
                                            onChange={(e) => setShowPaymentFooter(e.target.checked)} 
                                            style={{marginRight: '8px'}} 
                                        /> 
                                        Show Payment Footer in Invoice?
                                    </label>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className='invoice-summary'>
                        <div className='summary-grid'>
                            <div className='summary-inputs'>
                                <div className='form-section'>
                                    <h3>Payment Summary</h3>
                                    <p>Manage receipts in <Link to="/dashboard/payments">'Payments'</Link> tab.</p>
                                    <div className='form-grid'>
                                        <div><label>Previous Due (BDT):</label><input type="number" value={previousDue} readOnly={!allowEditPreviousDue} disabled={!allowEditPreviousDue} style={{backgroundColor: allowEditPreviousDue ? '#fff' : '#eee', textAlign: 'right'}} onChange={(e) => setPreviousDue(e.target.value)} onWheel={(e) => e.target.blur()} /></div>
                                        <label style={{display: 'flex', alignItems: 'center', margin: 0, paddingTop: '20px'}}><input type="checkbox" checked={allowEditPreviousDue} onChange={(e) => setAllowEditPreviousDue(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Edit Previous Due?</label>
                                        <div><label>Total Paid (BDT):</label><input type="number" value={totalPaid} readOnly={!allowEditTotalPaid} disabled={!allowEditTotalPaid} style={{backgroundColor: allowEditTotalPaid ? '#fff' : '#eee', textAlign: 'right'}} onChange={(e) => setTotalPaid(e.target.value)} onWheel={(e) => e.target.blur()} /></div>
                                        <label style={{display: 'flex', alignItems: 'center', margin: 0, paddingTop: '20px'}}><input type="checkbox" checked={allowEditTotalPaid} onChange={(e) => setAllowEditTotalPaid(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Edit 'Total Paid' Manually?</label>
                                        <div className="form-grid-item-full"><label style={{display: 'flex', alignItems: 'center', margin: 0, marginTop: '10px'}}><input type="checkbox" checked={showDiscount} onChange={(e) => setShowDiscount(e.target.checked)} style={{width: 'auto', marginRight: '8px'}} /> Add Discount?</label></div>
                                        {showDiscount && (<div className="form-grid-item-full"> <label>Discount Amount (BDT):</label><input type='number' value={discountAmount} onChange={e => setDiscountAmount(e.target.value)} placeholder='0.00' style={{textAlign: 'right'}} onWheel={(e) => e.target.blur()} /></div>)}
                                    </div>
                                    {paidEntries.length > 0 && (<><h4 style={{marginTop: '20px', marginBottom: '10px'}}>Logged Payments (Read-Only List):</h4><ul className='paid-entries-list'>{paidEntries.map(entry => (<li key={entry.id}><span>{entry.date} ({entry.method})</span><span><strong>- {formatCurrency(entry.amount)}</strong><button onClick={() => handleDeletePaymentEntry(entry)} className='remove-btn-small' style={{marginLeft: '10px'}} title='Remove this entry from Invoice'>X</button></span></li>))}</ul></>)}
                                </div>
                            </div>
                            <div className='summary-calculations'>
                                <h3>Final Calculation</h3>
                                <p>Total in USD: <strong>$ {formatCurrency(totalUsd)}</strong></p>
                                <p>Total in BDT (USD * {exchangeRate}): <strong>{formatCurrency(totalBdt)}</strong></p>
                                <p>Previous Due: <strong>{formatCurrency(previousDue)}</strong></p>
                                {showDiscount && discountAmount > 0 && (<p style={{color: 'red'}}>Discount: <strong>- {formatCurrency(discountAmount)}</strong></p>)}
                                <p>Total Paid: <strong>- {formatCurrency(totalPaid)}</strong></p>
                                <p className='final-total'>Final Total in BDT: <strong>{formatCurrency(finalTotalBdt)}</strong></p>
                            </div>
                        </div>
                    </div>
                    <button onClick={handleSaveInvoice} className='save-invoice-btn'>Save / Update Invoice</button>
                </>
            )}
            {loadingInvoice && <p>Loading Invoice Data...</p>}
        </div>
    )
}

export default NewInvoice;